import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule
} from '@ngneat/transloco';
import { Injectable, NgModule } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@env';
import { DataStorageService } from '@core/auth/services/data-storage.service';
import { PORTAL_VERSION } from './version.config';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http: HttpClient;
  constructor(private handler: HttpBackend, private dataStorage: DataStorageService) {
    this.http = new HttpClient(this.handler);
  }

  getTranslation(lang: string): Observable<Translation> {
    if (lang.includes('custom')) {
      return this.http
        .get<Translation>(
          // eslint-disable-next-line max-len
          `${
            environment.adminBucketUrl
          }/${this.dataStorage.getCompanyUuid()}/translation/${lang}.json?time=${PORTAL_VERSION}`
        )
        .pipe(catchError(() => of({})));
    } else {
      return this.http.get<Translation>(`/assets/i18n/${lang}.json?time=${PORTAL_VERSION}`);
    }
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: [
          'en',
          'en-custom',
          'en-GB',
          'en-GB-custom',
          'es',
          'es-custom',
          'fr',
          'fr-custom',
          'pt-BR',
          'pt-BR-custom',
          'de',
          'de-custom',
          'it',
          'it-custom',
          'ja',
          'ja-custom',
          'ko',
          'ko-custom',
          'zh',
          'zh-custom'
        ],
        defaultLang: 'en-custom',
        fallbackLang: 'en',
        missingHandler: {
          useFallbackTranslation: true
        },
        reRenderOnLangChange: true,
        prodMode: environment.production
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader }
  ]
})
export class TranslocoRootModule {}
